import { render, staticRenderFns } from "./NewDraft.vue?vue&type=template&id=5786fb08&"
import script from "./NewDraft.vue?vue&type=script&lang=js&"
export * from "./NewDraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports